<template>
  <b-navbar-nav class="nav-right">
    <!-- OK -->
    <b-navbar-nav v-if="ok">
      <b-nav-item @click="$emit('on-ok')">OK</b-nav-item>
    </b-navbar-nav>

    <!-- 完了 -->
    <b-navbar-nav v-if="complete">
      <b-nav-item @click="$emit('on-complete')">完了</b-nav-item>
    </b-navbar-nav>

    <!-- 指定メニュー -->
    <b-nav-form v-if="0 <= items.length">
      <b-nav-item
        v-for="item of items"
        v-bind:key="item.label"
        @click="item.click()"
        :disabled="item.disabled"
      >
        <div :class="['nav-button', { disabled: item.disabled }]">
          <b-icon v-if="item.icon" :icon="item.icon" />
          <span v-else>
            {{ item.label }}
          </span>
        </div>
      </b-nav-item>
    </b-nav-form>

    <!-- プリセットメニュー -->
    <b-nav-form v-if="preset" style="min-width: max-content">
      <!-- ソリューションパネル -->
      <b-nav-item class="nav-solution-links">
        <nav-bar-solution-button :solution-links="solutionLinks" :domain-id="domainId" />
      </b-nav-item>

      <!-- ユーザーメニュー -->
      <b-nav-item-dropdown
        id="menu-button"
        class="profile-menu"
        menu-class="profile-menu-container"
        right
        no-caret
      >
        <template v-slot:button-content>
          <profile-icon
            class="profile-menu"
            :user-name="userName"
            :id="userId"
            :image="userImage"
            :size="36"
            :use-hover-style="true"
          />
        </template>

        <!-- プロフィール -->
        <b-dropdown-item
          class="usermenu-item-profile usermenu-item-disable"
          disabled
          draggable="false"
        >
          <template v-slot:default>
            <div class="usermenu-item-username">{{ userName }}</div>
            <div class="usermenu-item-email">{{ userEmail }}</div>
          </template>
        </b-dropdown-item>
        <b-dropdown-divider />
        <!--
                <b-dropdown-divider />
                <b-dropdown-item>フローヘルプ</b-dropdown-item>
                <b-dropdown-item>掲示板ヘルプ</b-dropdown-item>
                <b-dropdown-item>お問い合わせ</b-dropdown-item>
                <b-dropdown-item>不具合報告</b-dropdown-item>
                <b-dropdown-item>ライセンス</b-dropdown-item>
                --->
        <!--
                <b-dropdown-item to="/1">デモ用組織１に切替</b-dropdown-item>
                <b-dropdown-item to="/2">デモ用組織２に切替</b-dropdown-item>
                <b-dropdown-item to="/post-message">新規投稿</b-dropdown-item>
                <b-dropdown-item @click="prepareDemoCategory">デモ(カテゴリ)を用意</b-dropdown-item>
                <b-dropdown-item @click="prepareDemoTopic">デモ(話題)を用意</b-dropdown-item>
                <b-dropdown-item @click="prepareDemoMessage">デモ(投稿)を用意</b-dropdown-item>
                <b-dropdown-item @click="prepareDemoComment">デモ(コメント)を用意</b-dropdown-item>
                <b-dropdown-item @click="prepareDemoImages">デモ画像を用意</b-dropdown-item>
                <b-dropdown-item @click="clearDemoImages">デモ画像を削除</b-dropdown-item>
                --->

        <b-dropdown-item @click="syncLoad">同期</b-dropdown-item>
        <b-dropdown-item id="menu-logout" @click="logout">ログアウト</b-dropdown-item>
        <b-dropdown-divider />

        <!-- 管理者用メニュー -->
        <b-dropdown-group
          v-if="isEditDomainSetting && hasFeature('domain-settings')"
          header="App管理"
        >
          <b-dropdown-item v-on:click="showDomainSetting">掲示板Appの設定</b-dropdown-item>
        </b-dropdown-group>
        <b-dropdown-divider v-if="isEditDomainSetting && hasFeature('domain-settings')" />
        <!-- 個人用メニュー -->
        <b-dropdown-group header="個人設定">
          <b-dropdown-item v-on:click="showSortCommentSetting">コメント並び順設定</b-dropdown-item>
        </b-dropdown-group>
        <b-dropdown-divider />
        <b-dropdown-group v-if="hasFeature('usermenu-help')" header="ヘルプ">
          <b-dropdown-item
            href="https://direct4b.com/ja/feature/apps/forum/"
            target="_blank"
            rel="noopener noreferrer"
            >掲示板について</b-dropdown-item
          >
          <b-dropdown-item
            href="https://help.direct4b.app/"
            target="_blank"
            rel="noopener noreferrer"
            >マニュアル</b-dropdown-item
          >
          <b-dropdown-item
            href="https://support.direct4b.com/apps"
            target="_blank"
            rel="noopener noreferrer"
            >サポート</b-dropdown-item
          >
        </b-dropdown-group>
        <b-dropdown-divider v-if="hasFeature('debug-sentry')" />
        <b-dropdown-item v-if="hasFeature('debug-sentry')" v-on:click="onClickDebugSentry"
          >Sentryエラーテスト</b-dropdown-item
        >

        <!-- クライアントタイプ変更 -->
        <b-dropdown-item
          v-if="hasFeature('debug-client-type') && env !== 'production'"
          v-b-modal="'debug-client-type'"
          >クライアントタイプ変更</b-dropdown-item
        >

        <!-- コピーライト -->
        <b-dropdown-item
          class="copyright"
          href="https://l-is-b.com/"
          target="_blank"
          rel="noopener noreferrer"
          >&copy; L is B Corp.</b-dropdown-item
        >
      </b-nav-item-dropdown>
    </b-nav-form>
    <b-nav-form v-if="close">
      <b-nav-item @click="$emit('on-close')" style="font-size: x-large; padding-right: 0px"
        ><b-icon icon="x"
      /></b-nav-item>
    </b-nav-form>
    <b-nav-form v-if="appClose">
      <b-dropdown
        v-if="env !== 'production'"
        text="開発用"
        variant="outline"
        toggle-class="debug-btn"
        :right="true"
      >
        <b-dropdown-item v-if="hasFeature('debug-sentry')" v-on:click="onClickDebugSentry"
          >Sentryエラーテスト</b-dropdown-item
        >

        <!-- クライアントタイプ変更 -->
        <b-dropdown-item
          v-if="hasFeature('debug-client-type') && env !== 'production'"
          v-b-modal="'debug-client-type'"
          >クライアントタイプ変更</b-dropdown-item
        >
      </b-dropdown>
      <b-nav-item @click="$emit('on-menu-open')" style="padding-right: 0px"
        ><b-icon icon="three-dots"
      /></b-nav-item>
      <b-nav-item @click="$emit('on-app-close')" style="font-size: x-large; padding-right: 0px"
        ><b-icon icon="x"
      /></b-nav-item>
    </b-nav-form>
    <b-nav-form v-if="empty">
      <b-nav-item disabled class="invisible"><b-icon icon="x" /></b-nav-item>
    </b-nav-form>
    <b-modal
      v-if="hasFeature('debug-client-type') && env !== 'production'"
      id="debug-client-type"
      @show="clientTypeCheckValue = clientType"
      @ok="debugChangeClientType"
    >
      <b-form-group>
        <b-form-radio v-model="clientTypeCheckValue" value="web">web</b-form-radio>
        <b-form-radio v-model="clientTypeCheckValue" value="ios">ios</b-form-radio>
        <b-form-radio v-model="clientTypeCheckValue" value="android">android</b-form-radio>
        <b-form-radio v-model="clientTypeCheckValue" value="desktop">desktop</b-form-radio>
        <b-form-radio v-model="clientTypeCheckValue" value="unknown">unknown</b-form-radio>
      </b-form-group>
    </b-modal>
  </b-navbar-nav>
</template>
<style lang="scss">
.profile-menu {
  .profile-menu-container {
    padding: 0px 0px 8px 0px;

    // ディバイダ
    .dropdown-divider {
      margin: 4px 0px 4px 0px;
      border-color: #d9d9d9;
    }

    // 各行のスタイル
    .dropdown-item {
      padding: 12px 16px;
      line-height: 16px;
    }

    // グループの場合
    .dropdown-header {
      padding: 4px 0px 4px 16px; // ヘッダタイトルのレイアウト
      font-size: 12px;
      line-height: 12px;
      cursor: default;
      user-select: none;

      // groupのアイテムは8px落とす
      & + ul .dropdown-item {
        padding-left: calc(16px + 8px);
      }
    }

    // コピーライト
    .copyright {
      cursor: default;
      text-align: right;

      .dropdown-item {
        display: inline-block;
        width: auto;
        padding: 4px 16px 0 0;
        color: #ccc;
        font-size: 14px;

        &:hover {
          background-color: inherit;
        }
      }
    }
  }
}

// プロフィール
.usermenu-item-profile {
  .dropdown-item {
    padding-top: 16px !important;
    display: flex;
    flex-direction: column;
    gap: 6px;
    cursor: default;

    &.disabled {
      color: #212529;
    }
  }
  .usermenu-item-username {
    font-size: 16px;
  }
  .usermenu-item-email {
    font-size: 12px;
    line-height: 12px;
  }
}

// ソリューションリンク
.nav-solution-links {
  padding-left: 0px;
  padding-right: 6px;
  > .nav-link {
    padding-left: 0px !important;

    .solution-menu-toggle {
      padding-left: 0px !important;
    }
  }
}

// 指定メニュー
.nav-button {
  width: 65px;
  height: 32px;
  border-radius: 16px;
  background-color: #ffffff;
  color: #00b7c6;
  text-align: center;
  line-height: 32px;

  &.disabled {
    opacity: 60%;
  }
}
</style>
<style>
.navbar-nav.nav-right .nav-item > .nav-link {
  color: white;
  padding-right: 0px;
}
.navbar-nav.nav-right .nav-item.profile-menu > .nav-link {
  padding: 0px;
}
.profile-menu {
  padding: 0px;
  display: inline-block;
  vertical-align: bottom;
}

/* スマホ表示ではソリューション一覧を出さない */
@media (max-width: 768px) {
  .nav-solution-links {
    display: none;
  }
}

@media (max-width: 768px) {
  .debug-btn {
    color: white !important;
    padding-right: 0px !important;
  }
}
@media (min-width: 768px) {
  .debug-btn {
    color: black !important;
    padding-right: 0px !important;
  }
}
</style>
<script lang="ts">
import { computed, defineComponent, ref, type PropType } from "vue";
import { useAppStore, useDomainStore, useUserStore } from "@/store";
import ProfileIcon from "../ProfileIcon.vue";
import NavBarSolutionButton from "@/components/solutions/NavBarSolutionButton.vue";
import { allowFeature, FeatureName } from "../../direct-app-config";
import { useLegacyRootEvent } from "@/composables/useLegacyRootEvent";

export type NavigationItem = { to: string; label: string; click?: string };
import { User } from "@/model";
import { AppLinkItem } from "../solutions/types";
import type { ClientType } from "@/store/domain-store";

/**
 * ナビゲーションバー（右側）
 *
 * ok         OKボタン
 * complete   完了ボタン
 * items      指定メニュー
 * preset     プリセットメニュー（ユーザーアイコンから始まるメニュー）
 * close      ✕ボタン
 *
 */
export default defineComponent({
  name: "nav-bar-right",
  components: { ProfileIcon, NavBarSolutionButton },
  props: {
    user: { type: Object as PropType<User>, default: () => User.createNotFoundUser() },
    /** ナビゲーションの右側メニューアイテム */
    ok: { type: Boolean, default: () => false },
    complete: { type: Boolean, default: () => false },
    items: { type: Array as PropType<NavigationItem[]>, default: () => [] },
    preset: { type: Boolean, default: () => false },
    close: { type: Boolean, default: () => false },
    appClose: { type: Boolean, default: () => false },
    domainId: { type: String, default: () => "" },
    // ソリューションアイコン一覧
    solutionLinks: { type: Array as PropType<AppLinkItem[]>, default: () => [] },
  },
  setup(props) {
    const rootEvent = useLegacyRootEvent();

    const clientTypeCheckValue = ref<ClientType>("unknown");

    const clientType = computed((): ClientType => {
      return useDomainStore().getClientType;
    });

    // NODE_ENV
    const env = computed((): string => {
      console.log(import.meta.env.MODE);
      return import.meta.env.MODE || "dev";
    });

    const empty = computed((): boolean => {
      return (
        props.ok == false &&
        props.complete == false &&
        props.items.length == 0 &&
        props.preset == false &&
        props.close == false &&
        props.appClose == false
      );
    });

    const userId = computed((): string => props.user.directId);
    const userEmail = computed((): string => props.user.email);
    const userName = computed((): string => props.user.name);
    const userImage = computed((): string => props.user.getProfileIconUrl());

    const isEditDomainSetting = computed((): boolean => {
      const me: User = useUserStore().me;
      return me.isOwnerRole(props.domainId) || me.isAdminRole(props.domainId);
    });
    // デモ関連ハンドラ
    const prepareDemoCategory = () => {
      rootEvent.emit("prepare-demo-category");
    };
    const prepareDemoTopic = () => {
      rootEvent.emit("prepare-demo-topic");
    };
    const prepareDemoMessage = () => {
      rootEvent.emit("prepare-demo-message");
    };
    const prepareDemoComment = () => {
      rootEvent.emit("prepare-demo-comment");
    };

    const prepareDemoImages = () => {
      rootEvent.emit("prepare-demo-images");
    };
    const clearDemoImages = () => {
      rootEvent.emit("clear-demo-images");
    };

    // Feature
    const hasFeature = (keyword: FeatureName): boolean => {
      return allowFeature(keyword);
    };

    // 組織設定ダイアログ表示
    const showDomainSetting = () => {
      rootEvent.emit("show-domain-setting");
    };

    const showSortCommentSetting = () => {
      rootEvent.emit("show-sort-comment-setting");
    };

    // 同期する(PC)
    const syncLoad = () => {
      rootEvent.emit("sync-data-alert");
    };

    const logout = () => {
      rootEvent.emit("logout");
    };

    // sentryテスト用のAPI呼び出し
    const onClickDebugSentry = async () => {
      const { ServerApiAccess } = await import("@/server-api-access");
      ServerApiAccess.debugSentry();
    };

    // debug用 クライアントタイプ変更(query書き換え)
    const debugChangeClientType = () => {
      let device: string = "";
      let invoker: string = "";
      switch (clientTypeCheckValue.value) {
        case "web": {
          device = "";
          invoker = "browser-direct";
          break;
        }
        case "desktop": {
          device = "";
          invoker = "desktop-direct";
          break;
        }
        case "ios": {
          device = "iPhone";
          invoker = "";
          break;
        }
        case "android": {
          device = "Android";
          invoker = "";
          break;
        }
        default: {
          device = "";
          invoker = "";
          break;
        }
      }
      useAppStore().setDevice(device);
      useAppStore().setInvokerApp(invoker);
    };

    return {
      clientTypeCheckValue,
      clientType,
      env,
      empty,
      userId,
      userEmail,
      userName,
      userImage,
      isEditDomainSetting,
      prepareDemoCategory,
      prepareDemoTopic,
      prepareDemoMessage,
      prepareDemoComment,
      prepareDemoImages,
      clearDemoImages,
      hasFeature,
      showDomainSetting,
      showSortCommentSetting,
      syncLoad,
      logout,
      onClickDebugSentry,
      debugChangeClientType,
    };
  },
});
</script>
